// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2VdCP","loaderOuter":"PageOverlayLoader_loaderOuter__2AC9_"};